import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import icons from '../../../data/icons';

class HomeLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popup: false
        };

        this.timer = null;
    }

    componentDidMount() {
        if (this.props.preloaderDone) {
            this.timer = setTimeout(() => {
                this.setState({ popup: true });
            }, 5000);
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.preloaderDone && this.props.preloaderDone) {
            this.timer = setTimeout(() => {
                this.setState({ popup: true });
            }, 5000);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        const { t } = this.props;

        return (
            <a
              href={ t('home.popup.link') }
              className="home-link"
            >
                <span
                  className="home-link-icon"
                  dangerouslySetInnerHTML={ { __html: icons.social.popup } }
                />
                <div className={ cx('home-link-text', { popup: this.state.popup }) } >
                    <span>{ t('home.popup.text') }</span>
                </div>
            </a>
        );
    }
}

HomeLink.propTypes = {
    t: PropTypes.func.isRequired,
    preloaderDone: PropTypes.bool.isRequired
};

export default HomeLink;



// WEBPACK FOOTER //
// ./src/components/content/home/HomeLink.jsx